<template>

  <div>
    <div class="uk-grid uk-child-width-expand@s">

      <div>
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div>
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedCategories"
            :key="selectedCategories"
            @change="filterChange"
            :options="categories"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Category')"
            name="categories"
        />
      </div>

      <div class="">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedYear"
            :key="selectedYear"
            @change="filterChange"
            :options="year"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Year')"
            name="year"
        />
      </div>

    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {searchResults} from "./index";
import {sfUtil} from "../../util";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
  additionalFilters: Object
})

const l = window.l

let additionalFilters = {...props.additionalFilters}

let taxonomies = {...props.taxonomies}
let categories = taxonomies['categories']
let year = taxonomies['year']

let searchQuery = ref('')
let selectedCategories = ref(new Set());
let selectedYear = ref(new Set());

let initialResultsHtml = null

const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  filterChildren,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedCategories.value = objectByValueKeys(new Set(searchParams.get('Categories')?.split(',')), categories)
  selectedYear.value = objectByValueKeys(new Set(searchParams.get('year')?.split(',')), year)
}

window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let categoriesSearch = [...filterChildren(categories, selectedCategories.value)].map(v => v[optionValueKey]).join(',')
  let yearSearch = [...selectedYear.value].map(v => v[optionValueKey]).join(',')

  if (categoriesSearch) {
    url.searchParams.set('Categories', categoriesSearch)
  } else {
    url.searchParams.delete('Categories')
  }

  if (yearSearch) {
    url.searchParams.set('year', yearSearch)
  } else {
    url.searchParams.delete('year')
  }

  if (yearSearch || categoriesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')
    url.searchParams.set('language', props.sfModel['Language'])

    applyAdditionalFilters(url)

  } else {
    url.searchParams.delete('searchQuery')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
    url.searchParams.delete('searchQuery')
    url.searchParams.delete('language')
    removeAdditionalFilters(url)
  }

  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  window.history.pushState({}, '', url);

  updateSearchResults()
}

let applyAdditionalFilters = (url) => {
  if(!additionalFilters) return
  for(let k in additionalFilters){
    url.searchParams.set(k, additionalFilters[k])
  }
}

let removeAdditionalFilters = (url) => {
  if(!additionalFilters) return
  for(let k in additionalFilters){
    url.searchParams.delete(k)
  }
}

let updateSearchResults = () => {
  initSearchResults()
  document.dispatchEvent(new Event('searchPredicateChanged'))
}

let searchResultsApp = null

let initSearchResults = () => {
  if (searchResultsApp) return
  searchResultsApp = Vue.createApp(searchResults, {initialResultsHtml})
  searchResultsApp.mount(searchResultsContainer)
  window.searchResultApp = searchResultsApp
}

</script>
